import React from "react";

const TotalCost = () => {
  return (
    <section className="total-cost">
      <div >
        <div className="col-md-12 all-one-title ">Total Cost</div>

        <div className="fare-detail-content ">
        <div className="col-md-12 initial-charge">Initial Charges</div>
      </div>

        <div className="fare-detail-content ">
          <div className="fare">
            <div className="b-time"> Booking Tariff</div>
            <div className="b-exact-time">45 hours, 0 Kms</div>
          </div>
          <div className="price">₹7,878 </div>
        </div>

        <div className="fare-detail-content cost-wrap ">
          <div className="fare">Total Cost</div>
          <div className="price">₹7,878</div>
        </div>
      </div>
    </section>
   
  );
};

export default TotalCost;
